export default __webpack_public_path__ + "static/media/1.bc587c78.png";